import './About.scss';
import star from '../../img/star.svg';
import team from '../../img/story.JPG';

const About = () => {
    return(
        <section className="About">
            <div className="About-description">
                <div className="About-description-header">
                    LEARN <br/>
                    <span>OUR</span> <br/>
                    STORY
                </div>
                <img className="About-description-star" alt='star' src={star}/>
                <a className="About-description-link" href='/about'>READ ABOUT IT.</a>
            </div>
            <img className="About-picture" alt="UCU Space Robotics team" src={team}/>

        </section>
    )
}
export default About;